var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useCallback } from 'react';
import { Formik } from 'formik';
import { isLeafNodePresent } from '../../utils/object-utils';
import { FormContextProvider } from './context';
import { useForm } from './hooks';
var FormManager = function (props) {
    var _a = props.blockSubmissionOnCustomErrors, blockSubmissionOnCustomErrors = _a === void 0 ? true : _a, _b = props.blockSubmissionOnCustomWarnings, blockSubmissionOnCustomWarnings = _b === void 0 ? false : _b, children = props.children, onSubmit = props.onSubmit;
    var formBag = useForm(props);
    var errors = formBag.errors, warnings = formBag.warnings;
    var _handleSubmit = useCallback(function (values, formikHelpers) {
        var setSubmitting = formikHelpers.setSubmitting;
        // Formik already checks presence of errors in its `errors` state.
        // We need to check whether there are any errors/warnings present in our custom `errors` and `warnings`
        // states.
        if (blockSubmissionOnCustomErrors && isLeafNodePresent(errors)) {
            setSubmitting(false);
            // TODO: Don't just return. See if an error needs to be thrown.
            return;
        }
        if (blockSubmissionOnCustomWarnings && isLeafNodePresent(warnings)) {
            setSubmitting(false);
            // TODO: Don't just return. See if an error needs to be thrown.
            return;
        }
        onSubmit(values, formikHelpers);
    }, [errors, warnings, blockSubmissionOnCustomErrors, blockSubmissionOnCustomWarnings, onSubmit]);
    return (React.createElement(FormContextProvider, { value: formBag },
        React.createElement(Formik, __assign({}, props, { onSubmit: _handleSubmit }), children)));
};
export default memo(FormManager);
